import _slicedToArray from "/opt/build/repo/.kyma-project-io/website/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useEffect } from 'react';

function useTimeout(cb) {
  var timeoutDelayMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTimeoutActive = _useState2[0],
      setIsTimeoutActive = _useState2[1];

  var savedRefCallback = useRef();
  useEffect(function () {
    savedRefCallback.current = cb;
  }, [cb]);

  function callback() {
    savedRefCallback.current && savedRefCallback.current();
    clear();
  }

  function clear() {
    setIsTimeoutActive(false);
  }

  function start() {
    setIsTimeoutActive(true);
  }

  useEffect(function () {
    if (isTimeoutActive) {
      var timeout = window.setTimeout(callback, timeoutDelayMs);
      return function () {
        window.clearTimeout(timeout);
      };
    }
  }, [isTimeoutActive]);
  return {
    clear: clear,
    start: start,
    stop: clear,
    isActive: isTimeoutActive
  };
}

export default useTimeout;